module.exports = __webpack_public_path__ + "static/img/c1g.64efc6ef.webp";